module.exports = __webpack_public_path__ + "fonts/inter-v11-latin-600.afd672b.ttf";